// GET ticket_delays/ returns two unrelated things on one endpoint: STANDBY entries, the
// technician-reported pause, and TICKET_DELAYED entries, the manager-only hold. They are
// labelled differently in the WO history and feed different banners, so every consumer
// splits the list rather than reading its first element.
type TypedNotification = {
  notification_type?: string | null;
};

export function standbyNotifications<T extends TypedNotification>(
  notifications: T[]
): T[] {
  return notifications.filter(
    (notification) => notification.notification_type === "STANDBY"
  );
}

export function delayNotifications<T extends TypedNotification>(notifications: T[]): T[] {
  return notifications.filter(
    (notification) => notification.notification_type === "TICKET_DELAYED"
  );
}
